import React, { createContext, useContext, useState } from "react";
import { DatasetFromLogDialog } from "./DatasetFromLogDialog";
import { Dataset } from "@/types/app/dataset";

interface DatasetDialogContextProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  logIds: string[];
  setLogIds: React.Dispatch<React.SetStateAction<string[]>>;
  selectedTarget: SelectedTarget;
  setSelectedTarget: React.Dispatch<React.SetStateAction<SelectedTarget>>;
}

const DatasetDialogContext = createContext<DatasetDialogContextProps | undefined>(undefined);

// The target file. FYI. This can be made fairly generic for all Files.
export type NewSelectedTarget = { type: "new"; name?: string };
export type ExistingSelectedTarget = { type: "add"; version?: Dataset };
export type SelectedTarget = NewSelectedTarget | ExistingSelectedTarget;

export const DatasetDialogProvider = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [selectedTarget, setSelectedTarget] = useState<SelectedTarget>({
    type: "add",
    version: undefined,
  });
  const [logIds, setLogIds] = useState<string[]>([]);

  const props = {
    open,
    setOpen,
    logIds,
    setLogIds,
    selectedTarget,
    setSelectedTarget,
  };

  return (
    <>
      <DatasetDialogContext.Provider value={props}>
        {children}
        <DatasetFromLogDialog
          {...props}
          onClose={() => {
            setOpen(false);
          }}
          onCreate={() => {
            setOpen(false);
            setLogIds([]);
          }}
        />
      </DatasetDialogContext.Provider>
    </>
  );
};

const useDatasetDialog = () => {
  const context = useContext(DatasetDialogContext);
  // if (context === undefined) {
  //   throw new Error("useDatasetDialog must be used within a DatasetDialogProvider");
  // }
  return context;
};

export default useDatasetDialog;
